
define('eteration/widgets/ui-closepopup',[
	'knockout'
	], function(ko,widgetUtil,moment){
		

	ko.bindingHandlers.closepopup = {
		    init: function (element, valueAccessor, allBindingsAccessor) {
		    	var container = $(element);
		       	$(document).on('click', function(event){
		    		if ( !$(event.target).is('.ui-icon') ) {
		    			if ( $(event.target).parents().index(container) == -1 ) {
		    				if ( container.is(":visible") ) {
		    					container.removeClass('on');
		    				}
		    			}
		    		}
		    	});
		    	
		    }
	};
	
	

		
});





